export default __webpack_public_path__ + "static/media/main-courses.bc29ba9c.jpg";